module.exports = __webpack_public_path__ + "static/media/Bean-Eater-Loaing.5b5dc839.svg";